<template>
  <v-flex xs12>
    <v-card class="pt-3">
      <v-layout row wrap align-center justify-space-between pb-3 px-3>
        <div class="layout row wrap">
          <div class="pa-2">
            <datetime 
              :phrases="{ ok: $lang.actions.ok, cancel: $lang.actions.cancel}"
              v-model="fromDate"
              type="datetime"
              :placeholder="$lang.labels.fromDate"
              class="datetime-btn primary--text" />
          </div>
          <div class="pa-2">
            <datetime 
            :phrases="{ ok: $lang.actions.ok, cancel: $lang.actions.cancel}" 
            v-model="toDate" 
            type="datetime" 
            :placeholder="$lang.labels.toDate" 
            class="datetime-btn primary--text" />            
          </div>
          <v-btn class="primary mx-2 my-2" @click="showLogs()">{{$lang.actions.showLogs}}</v-btn>
        </div>
        <v-text-field
          class="min-w max-w mx-2"
          v-model="search"
          append-icon="search"
          :label="$lang.labels.search"
          hide-details
        />
      </v-layout>
      <v-flex xs12 px-4 pb-3 v-if="err">
        <v-alert type="error" :value="true" class="my-0">{{err}}</v-alert>
      </v-flex>
      <transition name="fade">
        <div v-if="show">
          <v-data-table
            :headers="headers"
            :items="logs"
            :search="search"
            :loading="loading"
            :rows-per-page-items="[50, 100, 250, 500, { text:'All' , value: -1 }]"
          >
            <v-progress-linear height="6" slot="progress" color="primary" indeterminate />
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ formatDate(props.item.createdOn) }}</td>
              <td>{{ props.item.errorMessage }}</td>
              <td class="text-xs-left">
                <v-btn @click="showModal(props.item)" class="primary mx-0">{{$lang.actions.view}}</v-btn>
              </td>
            </template>
            <v-alert slot="no-results" :value="true" color="warning" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
        </div>
      </transition>
    </v-card>
    <v-dialog v-if="viewLogModal" v-model="viewLogModal" max-width="700">
      <view-log-modal :log="log" @close="viewLogModal = false"/>
    </v-dialog>
  </v-flex>
</template>

<script>
  import ViewLogModal from '@/components/modals/viewLog';
  import {DateTime} from 'luxon';

  export default {
    components: {
      ViewLogModal,
    },
    data() {
      return {
        err: '',
        show: false,
        loading: false,
        viewLogModal: false,
        log: null,
        fromDate: DateTime.local().minus({ hours: 4 }).toISO(),
        toDate: DateTime.local().plus({ hours: 2 }).toISO(),
        search: '',
        headers: [
          { text: this.$lang.labels.created, value: 'createdOn', align: 'left', },
          { text: this.$lang.labels.errorMessage, value: 'errorMessage', align: 'left', },
          { text: this.$lang.labels.actions, value: 'action', align: 'left', sortable: false, },
        ],
        logs: [],
      } 
    },
    methods: {
      showModal(log) {
        this.log = {
          id: log.id,
        }
        this.viewLogModal = true;          
      },
      formatDate(date) {
        return DateTime.fromISO(date).toFormat('yyyy-MM-dd HH:mm:ss');
      },
      showLogs() {
        this.loading = true;
        this.show = true;
        const data = {
          fromDate: this.fromDate,
          toDate: this.toDate,
        };
        this.$http.post('system/logs/getall' , data)
          .then((res) => {
            this.loading = false;
            if (res.body.status !== 'Success') {
              this.err = res.body.statusText;
              return;
            }
            this.logs = res.body.logs;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
          });
      },
      viewLog(log) {
        this.$router.push({ name: 'logDetail', params: {id: log.id}});
      },
    },
    watch: {
      err(val) {
        if (val !== '') {
          setTimeout(() => { this.err = ''; }, 5000);
        }
      },
    },
    created() {
      this.showLogs();
    }
  };
</script>



// WEBPACK FOOTER //
// SystemLogs.vue?2863d04e